// HydroponicFarmConstruction.js
import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { FcNext } from "react-icons/fc";
import { FaAngleRight } from "react-icons/fa";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useEffect } from "react";

const HydroponicFarmConstruction = () => {
  const { state, city } = useParams();
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState([]);

  const handelSubmit = (values, actions) => {
    values = { ...values, origin: "HFC-Alpha" };

    // const formData = new FormData();

    // for (let key in values) {
    //   if (values[key] instanceof File || values[key] instanceof Blob) {
    //     formData.append(key, values[key]);
    //   } else if (typeof values[key] === "object" && values[key] !== null) {
    //     formData.append(key, JSON.stringify(values[key]));
    //   } else {
    //     formData.append(key, values[key]);
    //   }
    // }

    // const headers = { "content-type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Enquiry Created Cuccessfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/get-district/?state=${state}`)
      .then((res) => {
        if (res.status === 201) {
          const first15Districts = res.data
            .slice(0, 15)
            .map((d) => d.toLowerCase());

          setDistrict(first15Districts);
        } else {
          Toast("error", "Error while getting application!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [state]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Helmet>
        <title>Hydroponic Farm Construction in {city}, {state}</title>
        <meta
          name="description"
          content={`Kryzen Biotech builds advanced hydroponic farms in ${city}, ${state}. From design to installation, we help farmers maximize crop yield and adopt sustainable soilless farming in ${city}.`}
        />
        <meta
          name="keywords"
          content={`
      Hydroponic farm construction in ${city},
      Hydroponic farm construction in ${state},
      Hydroponic system setup ${city},
      Hydroponic system setup ${state},
      Commercial hydroponic farming ${city},
      Commercial hydroponic farming ${state},
      Soilless farming ${city},
      Soilless farming ${state},
      Modern farming solutions ${city},
      Modern farming solutions ${state},
      Kryzen Biotech hydroponics ${city},
      Kryzen Biotech hydroponics ${state}
    `}
        />
        <meta
          property="og:title"
          content={`Hydroponic Farm Construction in ${city}, ${state}`}
        />
        <meta
          property="og:description"
          content={`Set up a modern hydroponic farm in ${city}, ${state}. We design and build commercial hydroponic systems with end-to-end support.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/hydroponic-farm-construction/${state}/${city}`}
        />
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/hydroponic-farm-construction/${state}/${city}`}
        />
      </Helmet>

      

      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <h1
          className="text-center fw-bold text-uppercase"
          style={{ fontSize: "2.2rem" }}
        >
          Hydroponic Farm Construction in {city}, {state}!
        </h1>
        <hr></hr>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="p-1 p-md-2">
              {/* Content Section */}
              <div className="">
                <h2 className="lh-lg fs-1 text-center">
                  Kryzen Biotech is a leading name in{" "}
                  <strong>Hydroponic Farm Construction</strong>, helping farmers
                  and agripreneurs in {city}, {state} adopt{" "}
                  <strong>soilless farming technology</strong>. Our modern
                  hydroponic systems ensure{" "}
                  <strong>
                    higher yields, year-round cultivation, and premium quality
                    produce
                  </strong>
                  .
                </h2>
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755854072/hydroponic_hswddn.jpg"
                  alt="middle img"
                  className="w-100 my-3"
                />
                {/* <p className="fs-6 lh-lg mt-3">
                        Eligible beneficiaries can avail <strong>interest subvention of 3% per annum</strong> on loans up to ₹2 crore for 7 years. <strong>Credit guarantee coverage</strong> is available for loans up to ₹2 crore, easing collateral requirements.
                      </p>
      
                      <p className="fs-6 lh-lg">
                        Hydroponics projects in <strong>{city}</strong> benefit from reduced financial burden for NFT systems, deep-water culture, vertical farming, and protected cultivation, especially in {state}.
                      </p>
      
                      <p className="fs-6 lh-lg">
                        The scheme also supports <strong>FPOs, startups, and agri-tech companies</strong> for collaborative hydroponics projects and commercial-scale farms. Kryzen Biotech helps in project preparation, subsidy consultation, and execution.
                      </p> */}
                <p className="fs-2 lh-lg mt-5">
                  We specialize in designing and constructing{" "}
                  <strong>
                    flatbed hydroponics, growbags systems, NFT channels, A-frame
                    and vertical hydroponic setups
                  </strong>{" "}
                  tailored to the climatic conditions of {state}. With{" "}
                  <strong>
                    nutrient-rich water systems and automated controls
                  </strong>
                  , our hydroponic farms guarantee{" "}
                  <strong>efficiency, sustainability, and profitability</strong>
                  .
                </p>{" "}
                <p className="fs-2 lh-lg">
                  {" "}
                  In {city}, farmers and entrepreneurs are increasingly adopting
                  hydroponics to grow{" "}
                  <strong>
                    lettuce, spinach, herbs, strawberries, exotic vegetables,
                    and flowers
                  </strong>
                  . Hydroponic farming allows{" "}
                  <strong>
                    faster growth, reduced pesticide usage, and water savings of
                    up to 90%
                  </strong>{" "}
                  compared to soil-based farming.
                </p>{" "}
                <p className="fs-2 lh-lg">
                  {" "}
                  Our <strong>end-to-end solutions</strong> include{" "}
                  <strong>
                    DPR preparation, farm design, material supply, construction,
                    automation, and farmer training
                  </strong>
                  . Kryzen Biotech ensures that your hydroponic project in{" "}
                  {state} is built with{" "}
                  <strong>
                    the latest technology, structural stability, and sustainable
                    practices
                  </strong>
                  .
                </p>{" "}
                <p className="fs-2 lh-lg">
                  We have successfully delivered{" "}
                  <strong>hydroponic farms across India</strong>, empowering
                  farmers in {state} to boost income through{" "}
                  <strong>
                    modern farming techniques and government subsidy schemes
                  </strong>
                </p>{" "}
                {/* <p className="fs-2 lh-lg">
                        {" "}
                        In conclusion, the <strong>AIF Hydroponic Subsidy</strong> is
                        a golden opportunity for farmers and agri-entrepreneurs in{" "}
                        {state}. Whether you are based in {city} or agricultural belts
                        like Nashik, Pune, and Nagpur, the AIF scheme offers{" "}
                        <strong>
                          {" "}
                          affordable financing, interest subvention, and credit
                          support{" "}
                        </strong>{" "}
                        for building future-ready farming infrastructure.{" "}
                      </p> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mt-4 mt-md-5 p-3 border d-flex flex-column  align-items-center">
            {/* Form Section */}
            <div>
              <Formik
                initialValues={enquiryInfo}
                validationSchema={enquirySchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form
                    className="card p-3 p-md-5 bg-green-lt"
                    // style={{ backgroundColor: "lightgreen" }}
                  >
                    <h2
                      className="fs-2 fs-md-3 text-center mb-3"
                      style={{ color: "black" }}
                    >
                      Join an expert call for hydroponic farm construction in{" "}
                      {city}, {state}
                    </h2>
                    <hr></hr>
                    <div className="mb-3">
                      <label className="form-label required" style={{ color: "black" }}>
                        First Name
                      </label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label required" style={{ color: "black" }}>
                        Last Name
                      </label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    {/* <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Full Name
                      </label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.fullName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{ color: "black" }}
                      >
                        Email
                      </label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      {/* <FormSubmitButton buttonText="Submit" /> */}
                      <button
                        class="btn btn-github  btn mx-1 mt-2 text-center"
                        isSubmitting={props.isSubmitting}
                      >
                        <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="">
              <img
                className="w-100"
                style={{ height: "630px" }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                alt="conditions img"
              />
            </div>
          </div>
        </div>

        {/* Conditions Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/why_choose_kryzen_uf7slk.jpg"
              alt="why choose kryzen img"
            />
          </div>
          <div className="col-12 col-md-8">
            <h2 className="fw-bold text-uppercase mb-3 fs-1 mt-5 mt-md-0 mt-lg-0">
              Why Choose Kryzen Biotech for Hydroponic Farm Construction in{" "}
              {city}, {state}?
            </h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              <strong>Kryzen Biotech</strong> is a trusted partner for
              hydroponic farm construction in Pune and across Maharashtra. By
              combining innovative soilless farming systems with customized
              designs, automation, and continuous farmer support, Kryzen Biotech
              ensures that growers not only build sustainable farms but also
              achieve long-term profitability. With expertise in subsidy
              facilitation and advanced technologies, we make modern farming
              accessible and successful for every agri-entrepreneur.
            </p>
            <ol className="fs-2 lh-lg ">
              <li>
                Customized hydroponic designs for local conditions in {state}.
              </li>
              <li>Soilless systems with high water-use efficiency.</li>
              <li>Advanced automation for nutrient and pH management.</li>
              <li>
                Vertical, A-frame, NFT, flatbed & growbag hydroponic setups.
              </li>
              <li>
                Assistance with{" "}
                <strong>government subsidies and project funding</strong>.
              </li>
              <li>Training, agronomy support & handholding for success.</li>
            </ol>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-8">
            <h2 className="fw-bold mb-3 text-uppercase fs-1">
              Benefits of Hydroponic Farming in {city}, {state}
            </h2>
            <hr />

            <p className="mt-4 fs-2 lh-lg">
              <b>Hydroponic farming in {city}</b>, {state} is rapidly
              transforming the agricultural landscape by providing sustainable
              and profitable solutions for both rural and urban growers. With
              the ability to conserve water, maximize yields, and produce
              chemical-free crops, hydroponics offers a modern pathway to meet
              rising food demands. <b>Kryzen Biotech</b> supports farmers and
              agri-entrepreneurs in adopting these advanced techniques by
              delivering customized designs, automation solutions, and agronomy
              support, ensuring that hydroponic farms achieve long-term success
              and profitability.
            </p>
            <ol className="fs-2 lh-lg">
              <li>
                By adopting hydroponic farming in {city}, {state}, farmers can
                <strong> save up to 90% water</strong>.
              </li>
              <li>
                Achieve <strong>5–10 times higher productivity</strong>.
              </li>
              <li>
                Cultivate <strong>residue-free crops</strong>.
              </li>
              <li>
                Enable <strong>urban & peri-urban farming</strong>.
              </li>
              <li>
                Ensure <strong>year-round production</strong>.
              </li>
              <li>
                Improve <strong>efficient resource management</strong>.
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/benifits_v6xubk.jpg"
              alt="benefits img"
            />
          </div>
        </div>
        <hr></hr>
        <div className="row mt-7">
          {/* Image Section */}
          <div className="col-12 col-md-5 mt-4 mt-md-0 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <img
              className="card img-fluid"
              style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
              alt="Shark Tank"
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6 ps-md-2 ms-md-5  text-md-start">
            <h1 className="fw-bold text-uppercase mb-3 fs-1 mt-3 mt-md-0">
              We build best protected farming technology for the world!
            </h1>
            <hr className="mx-auto mx-md-0" />
            <p className="mt-4 fs-2 lh-lg">
              Build a commercially profitable farm anywhere and earn up to
              ₹1,25,000 per month from just 5000 sqft.
            </p>
            <p className="mt-4 fs-2 lh-lg">
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <h3 className="fs-1 pb-3 text-uppercase">Conclusion</h3>
          <hr></hr>
          <p className="fs-2">
            In conclusion,{" "}
            <strong>
              Hydroponic Farm Construction in {city}, {state}
            </strong>{" "}
            is a profitable investment for farmers and agripreneurs. With the
            growing demand for{" "}
            <strong>fresh, chemical-free, and nutrient-rich produce</strong>,
            hydroponics ensures{" "}
            <strong>
              higher profitability, resource efficiency, and future-ready
              farming
            </strong>
            . Kryzen Biotech is your trusted partner in building successful
            hydroponic ventures.
          </p>
        </div>
        <div className="row mt-7">
          <div className="row">
            <h2 className="fw-bold text-uppercase mb-3 fs-1">
              Explore Hydroponic Farm Construction in Other Cities of {state}
            </h2>
            <hr />

            {district.slice(0, 15).map((city, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-4">
                <ul className="fs-3 lh-lg">
                  <li>
                    <a
                      href={`/hydroponic-farm-construction/${state}/${city.toLowerCase()}`}
                      className="text-decoration-none text-success"
                    >
                      Hydroponic Farm Construction in {city}, {state}
                    </a>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{height:"380px"}}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>

      <FooterwithoutLogin />
    </div>
  );
};

export default HydroponicFarmConstruction;

// firstName: '',
// lastName: '',
// fullName: '',
// // country: '',
// mobileNumber: '',
// // alternativeNumber: '',
// whatsappNumber: '',
// address1: '',
// address2: '',
// // city: '',
// // state: '',
// email: '',
// notes:'',
// // customerMessage: '',
// origin: 'Kisan_Exhibition_2024',
// interestedProduct: '',
// plannedArea: '',
// gst_number:'',
// businessName:''
